import _ from 'lodash';

import getPositionAndOffset from '../v2/viewer/getPositionAndOffset';

// TODO: Optimize
export const deleteAction = (actions, actionId) => {
  const action = actions.find((item) => item.id === actionId);

  // If it's a collapsed section, delete it, along with the contents
  if (action.kind === 'section' && action.collapsed) {
    return deleteSectionAndContents(actions, actionId);
  }
  return actions.filter((action) => action.id !== actionId);
};

export const deleteSectionAndContents = (actions, sectionId) => {
  const sectionIndex = actions.findIndex((action) => action.id === sectionId);
  const before = actions.slice(0, sectionIndex);
  const nextSectionIndex = actions.findIndex((action, index) => action.kind === 'section' && index > sectionIndex);

  const after = actions.slice(nextSectionIndex > -1 ? nextSectionIndex : actions.length);
  const ret = [...before, ...after];

  return ret;
};

export const getSectionContents = (actions, sectionId) => {
  const sectionIndex = actions.findIndex((item) => item.id === sectionId);

  return _.takeWhile(actions.slice(sectionIndex + 1), (value) => value.kind !== 'section').map((item) => item.id);
};

// number of steps within the section
export const getSectionContentNum = (actions, sectionId) => {
  const sectionIndex = actions.findIndex((item) => item.id === sectionId);

  return _.takeWhile(actions.slice(sectionIndex + 1), (value) => value.kind !== 'section').map((item) => item.id).length;
};

export const collapseSectionById = (actions, sectionId, collapsed = true) => {
  const section = actions.find((item) => item.id === sectionId);

  if (!section) {
    return actions;
  }
  return collapseSection(actions, section, collapsed);
};

export const collapseSection = (actions, section, collapsed = true) => {
  const toBeCollapsed = actions.findIndex((item) => item.id === section.id);

  if (toBeCollapsed === -1) {
    return actions;
  }
  const firstPart = actions.slice(0, toBeCollapsed);
  let nextSectionIndex = actions.slice(toBeCollapsed + 1).findIndex((item) => item.kind === 'section');

  if (nextSectionIndex !== -1) {
    nextSectionIndex += toBeCollapsed + 1;
  }
  const partToHide = actions.slice(toBeCollapsed + 1, ...(nextSectionIndex !== -1 ? [nextSectionIndex] : []));

  const newActionList = [
    ...firstPart,
    { ...actions[toBeCollapsed], collapsed },
    ...partToHide.map((item) => ({ ...item, hidden: collapsed })),
    ...(nextSectionIndex !== -1 ? actions.slice(nextSectionIndex) : [])
  ];

  return newActionList;
};

export const addCreatedStackToActions = (actions, stack, actionIdsToStack) => {
  let visibleActions = [...actions];
  // all selected sections
  const selectedSections = visibleActions.filter((action) => actionIdsToStack.includes(action.id) && action.kind === 'section');
  const updatedSections = [...selectedSections].map((item) => ({ ...item, selected: false, collapsed: false }));
  const firstSelectedActionIndex = visibleActions.findIndex((action) => action.selected);
  // add stack

  visibleActions.splice(firstSelectedActionIndex, 0, stack);
  // remove all selected actions
  visibleActions = visibleActions.filter((action) => !actionIdsToStack.includes(action.id));
  // find stack index
  const stackIndex = visibleActions.findIndex((action) => action.id === stack.id);
  // add updatedSections on top of the stack

  visibleActions.splice(stackIndex, 0, ...updatedSections);
  return visibleActions;
};

export const updateStackActions = (actions, stack, actionIdsToStack) => {
  let visibleActions = [...actions];
  const stackedActionIndex = visibleActions.findIndex((action) => action.id === stack.id);
  const selectedSections = visibleActions.filter((action) => actionIdsToStack.includes(action.id) && action.kind === 'section');
  const updatedSections = [...selectedSections].map((item) => ({ ...item, selected: false, collapsed: false }));
  // switch existing stack with new one

  visibleActions = visibleActions.map((action) => {
    if (action.id === stack.id) return stack;
    return action;
  });
  // remove stackId from actionIdsToStack
  const filteredActionIds = actionIdsToStack.filter((id) => id !== stack.id);
  // remove all selected actions except merged stack

  visibleActions = visibleActions.filter((action) => !filteredActionIds.includes(action.id));
  // find stack index
  const stackIndex = visibleActions.findIndex((action) => action.id === stack.id);
  // add updatedSections on top of the stack

  visibleActions.splice(stackIndex, 0, ...updatedSections);
  return visibleActions;
};

export const unstackActions = (actions, stack) => {
  const stackIndex = actions.findIndex((action) => action.id === stack.id);

  actions.splice(stackIndex, 0, ...stack.stack_actions);
  const updatedActions = actions.filter((action) => action.id !== stack.id);

  return updatedActions;
};
export const optimisticStackUpdate = (actions) => {
  let visibleActions = [...actions];
  // all action ids to stack cant use just selected flag because some sections can be collapsed
  let actionIdsToStack = [];

  visibleActions.forEach((action) => {
    if (action.kind === 'section' && action.selected) {
      actionIdsToStack.push(action.id);
      if (action.collapsed) {
        actionIdsToStack = actionIdsToStack.concat(getSectionContents(visibleActions, action.id));
      }
    } else if (action.selected) {
      actionIdsToStack.push(action.id);
    }
  });

  // / all selected actions
  const selectedActions = visibleActions.filter((action) => actionIdsToStack.includes(action.id) && action.kind !== 'section');
  // all selected sections
  const selectedSections = visibleActions.filter((action) => actionIdsToStack.includes(action.id) && action.kind === 'section');
  const updatedSections = [...selectedSections].map((item) => ({ ...item, selected: false, collapsed: false }));
  const firstStack = selectedActions.find((action) => action.kind === 'stack');
  const firstAction = visibleActions.find((action) => action.selected);
  const firstSelectedActionIndex = visibleActions.findIndex((action) => action.selected);

  // merge all stack actions and comments
  const stack_actions = [];
  const comments = [];

  selectedActions.forEach((action) => {
    if (action.kind === 'stack') {
      stack_actions.push(...action.stack_actions);
      comments.push(
        ...action.stack_actions.reduce((acc, currAct) => {
          acc.push(...currAct.comments);
          return acc;
        }, [])
      );
    } else {
      stack_actions.push(action);
      comments.push(...action.comments);
    }
  });

  let newActionStack;

  if (firstStack) {
    // update existing stack
    newActionStack = {
      ...firstStack,
      stack_actions: [...firstStack.stack_actions, ...stack_actions],
      comments
    };
    // switch existing stack with new one
    visibleActions = visibleActions.map((action) => {
      if (action.id === newActionStack.id) return newActionStack;
      return action;
    });
    // remove stackId from actionIdsToStack
    const filteredActionIds = actionIdsToStack.filter((id) => id !== firstStack.id);
    // remove all selected actions except new stack

    visibleActions = visibleActions.filter((action) => !filteredActionIds.includes(action.id));
    // find stack index
    const stackIndex = visibleActions.findIndex((action) => action.id === firstStack.id);
    // add updatedSections on top of the stack

    visibleActions.splice(stackIndex, 0, ...updatedSections);
  } else {
    // create new stack
    newActionStack = {
      kind: 'stack',
      description: stack_actions
        .map((action) => action.description)
        .join('\n')
        .trim(),
      stack_actions,
      sort_order: firstAction.sort_order,
      comments,
      id: 'stack-waiting-update'
    };
    // add stack
    visibleActions.splice(firstSelectedActionIndex, 0, newActionStack);
    // remove all selected actions
    visibleActions = visibleActions.filter((action) => !actionIdsToStack.includes(action.id));
    // find stack index
    const stackIndex = visibleActions.findIndex((action) => action.id === newActionStack.id);
    // add updatedSections on top of the stack

    visibleActions.splice(stackIndex, 0, ...updatedSections);
  }
  return visibleActions;
};

export const getTitleByActionKindOrType = (kind, type) => {
  let title = '';

  if (kind == 'section') title = 'Header Title';
  if (kind == 'instruction' && !type) title = 'Step';
  if (kind == 'instruction' && type == 'tip') title = 'Tip!';
  if (kind == 'instruction' && type == 'warning') title = 'Alert!';
  return title;
};

export const getScreenAndMousePosition = (action, containerWidth, containerHeight, imageSize, scaleFactor) => {
  // Make sure to handle cases where position is missing.
  let { position } = action;
  let imageWithoutClick = false;

  if (!position) {
    imageWithoutClick = true;
    if (!imageSize) {
      position = { x: 0, y: 0 };
    } else {
      position = { x: imageSize.width / 2, y: imageSize.height / 2 };
    }
  }

  let { x: mouseX, y: mouseY } = position;
  // In the case of actions with images but without clicks, we place the mouse cursor at the center of the image
  // However, if the image is cropped (and without a click), the code above uses the size of the
  // user_cropped_screenshot (since that's the image we show).
  // In this case, there is no need to take crop position into account.

  if (action.user_cropped_screenshot && !imageWithoutClick) {
    // Original mouse position on the screenshot
    mouseX = position.x - action.user_cropped_screenshot.x;
    mouseY = position.y - action.user_cropped_screenshot.y;
  }
  const [x, horizontal] = getPositionAndOffset(containerWidth, imageSize?.width ?? 0, mouseX, scaleFactor ?? 1);
  const [y, vertical] = getPositionAndOffset(containerHeight, imageSize?.height ?? 0, mouseY, scaleFactor ?? 1);

  return {
    screenPosition: { vertical, horizontal },
    mousePosition: { x, y }
  };
};

export const isGif = (screenshotUrl) => {
  if (!screenshotUrl) return false;

  return screenshotUrl.split('?')[0].endsWith('.webp') || screenshotUrl.split('?')[0].endsWith('.gif');
};
